import { DateTime } from 'luxon';
import { DATE_TIME_FORMAT, DATE_TIME_FORMAT_12H, FULL_DATE_TIME_FORMAT_12H, DATE_TIME_CALENDAR } from '@constants/date-time.constants';

export const getDateTime12H = (dateTime: string) => {
	return DateTime.fromISO(dateTime).toFormat(DATE_TIME_FORMAT_12H).replace('AM', 'am').replace('PM', 'pm');
};

export const getFullDateTime12H = (dateTime: string) => {
	return DateTime.fromISO(dateTime).toFormat(FULL_DATE_TIME_FORMAT_12H).replace('AM', 'am').replace('PM', 'pm');
};

export const getDiffMilliSeconds = (from: string | Date, to: string | Date) => {
	return new Date(from).getTime() - new Date(to).getTime();
};

export const getDate = (dateTime: string) => {
	return DateTime.fromISO(dateTime).toFormat(DATE_TIME_FORMAT);
};

export const formatDate = (dateTime: Date, format: string) => {
	return DateTime.fromISO(dateTime.toISOString()).toFormat(format);
};

export const formatDateTimeWithAmPm = (dateTime: Date) => {
	return formatDate(dateTime, DATE_TIME_CALENDAR).replace('AM', ' am').replace('PM', ' pm');
};

export const isWithinLastMinutes = (givenDateTime: DateTime, minutes: number) => {
	const now = DateTime.now();

	const minutesBefore = now.minus({ minutes });

	return givenDateTime >= minutesBefore;
};
